<template>
  <div>
    <div>
      <perio-header></perio-header>
    </div>
    <div>
      <con></con>
    </div>
    <div>
      <perio-footer></perio-footer>
    </div>
  </div>
</template>

<script>
import perioHeader from "../components/home/headears.vue"
import perioFooter from "../components/home/footers.vue"
import con from "../components/details/details"
  export default {
    components:{
      perioHeader,perioFooter,con
    }
  }
</script>

<style scoped>

</style>